import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/modules/shared/services';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {

  constructor(
    public util: UtilService,
    public dataService: DataService
  ) { }

  ngOnInit(): void {
    
  }

}
